import clsx from "clsx";
import style from "./side-widget.scss";
import Loadable from 'react-loadable';
import LazyLoad from "utils/lazy-load";
import { useWidget } from "context/widget.context";
import { FormWidgetProvider } from "context/form.context";
import { jsonColorConvertor } from "utils/colorConvertor";
import Loading from "components/loading/loading";

const CloseIcon = LazyLoad({ loader: () => import('components/icons/close/close-contained'), });
const SuccessMessage = LazyLoad({ loader: () => import('components/layout/success-message'), });
const Copyright = LazyLoad({ loader: () => import('components/layout/copyright'), });

const WidgetFormFields = Loadable({
  loader: () => import("components/form/multi-step/widget-form-fields"),
  loading: () => <Loading isCircle />
});


const SideWidget = () => {
  const {
    isFormSubmitted,
    closeWidget,
    openWidget,
    isWidgetOpen,
    position,
    oncePerUser,
    formData: { title, buttonBackground, submitTextColor, formSlug }
  } = useWidget()
  const isWidgetSubmittedOnce = localStorage.getItem(`formaloo-widget-submit-${formSlug}`)

  const customizedStyle = {
    backgroundColor: jsonColorConvertor(buttonBackground),
    color: jsonColorConvertor(submitTextColor)
  }
  const WidgetButton = (
    <div
      style={customizedStyle}
      className={style.collapseButtonWrapper}
      onClick={() => { openWidget(true) }}
    >
      <span className={style.title}>{title}</span>
    </div>
  )

  const WidgetForm = (
    <div className={style.openedFormWrapper} >
      <CloseIcon onClick={() => closeWidget(true)} style={customizedStyle} />
      <div className={style.formWrapper}>
        {isFormSubmitted
          ? <SuccessMessage />
          : <FormWidgetProvider style={style}>
            <WidgetFormFields />
          </FormWidgetProvider>}
      </div>
      <div className={style.footer}> <Copyright /></div>
    </div>
  )
  if (isWidgetSubmittedOnce && oncePerUser) return null
  return (
    <div className={clsx({
      [style.stickyRight]: Boolean(position === 'right'),
      [style.stickyLeft]: Boolean(position === 'left'),
      [style.stickyRightBottom]: Boolean(position === 'right-bottom'),
      [style.stickyLeftBottom]: Boolean(position === 'left-bottom'),
      [style.stickyButton]: true,
    })}>

      {!isWidgetOpen && WidgetButton}
      {isWidgetOpen && WidgetForm}
    </div>

  )
}
export default SideWidget